import { getDefaultEntryPointAddress, getUserOperationHash, packUo, } from "../utils/index.js";
export const getVersion060EntryPoint = (chain, address = getDefaultEntryPointAddress(chain)) => {
    return {
        version: "0.6.0",
        address,
        chain,
        packUserOperation: (userOperation) => {
            return packUo(userOperation);
        },
        getUserOperationHash: (userOperation) => {
            return getUserOperationHash(userOperation, address, chain.id);
        },
    };
};
//# sourceMappingURL=0.6.js.map